import * as utils from './utils/index.js';

/**
 * Inicializa el menú principal:
 * - Controla apertura/cierre (hamburguesa).
 * - Maneja overlay para cerrar tocando fuera.
 * - Inserta toggles para submenús en móvil.
 * - Añade clases de hover/enfoque a elementos interactivos.
 */
export function initMenu() {
  const nav = document.getElementById('primaryNav');
  const toggle = document.getElementById('navToggle');
  const closeBtn = document.getElementById('navClose');
  const overlay = document.getElementById('navOverlay');
  if (!nav || !toggle) return;

  // Abrir/cerrar navegación
  utils.on(toggle, 'click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    nav.classList.toggle('is-open', !isOpen);
    if (overlay) overlay.hidden = isOpen;
  });

  // Cerrar con el botón de cierre en móvil
  if (closeBtn) {
    utils.on(closeBtn, 'click', () => {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (overlay) overlay.hidden = true;
    });
  }

  // Cerrar al tocar el overlay
  if (overlay) {
    utils.on(overlay, 'click', () => {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      overlay.hidden = true;
    });
  }

  // Añadir toggles por submenú (en desktop el CSS pone pointer-events: none)
  const items = nav.querySelectorAll('li.menu-item-has-children');
  items.forEach((li, idx) => {
    const sub = li.querySelector(':scope > ul.sub-menu');
    const link = li.querySelector(':scope > a, :scope > span');
    if (!sub || li.querySelector(':scope > button.submenu-toggle')) return;

    const subId = sub.id || `submenu-${idx}-${Math.random().toString(36).slice(2, 7)}`;
    sub.id = subId;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'submenu-toggle';
    btn.setAttribute('aria-controls', subId);
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Abrir submenú');

    // Inserta tras el enlace padre para mantenerlo navegable
    if (link && link.parentNode) {
      link.parentNode.insertBefore(btn, link.nextSibling);
    } else {
      li.insertBefore(btn, sub);
    }

    btn.style.touchAction = 'manipulation';

    const toggleSubmenu = () => {
      const willOpen = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(willOpen));
      btn.setAttribute('aria-label', willOpen ? 'Cerrar submenú' : 'Abrir submenú');
      li.classList.toggle('is-open', willOpen);
    };

    // pointerup: el click en móvil espera ~300ms (doble toque) y traga el segundo tap.
    let ignoreNextClick = false;
    utils.on(btn, 'pointerup', (e) => {
      if (e.button !== 0) return;
      if (e.pointerType === 'mouse') return;
      e.preventDefault();
      e.stopPropagation();
      ignoreNextClick = true;
      toggleSubmenu();
    });
    utils.on(btn, 'click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (ignoreNextClick) {
        ignoreNextClick = false;
        return;
      }
      toggleSubmenu();
    });
  });

  // Cerrar el drawer al pasar a laptop (mismo corte que .laptop() / @screen__l).
  const laptopMq = window.matchMedia('(min-width: 1000px)');
  const closeDrawerOnDesktop = () => {
    if (!laptopMq.matches) {
      return;
    }
    nav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    if (overlay) {
      overlay.hidden = true;
    }
  };
  if (laptopMq.addEventListener) {
    laptopMq.addEventListener('change', closeDrawerOnDesktop);
  } else {
    laptopMq.addListener(closeDrawerOnDesktop);
  }

  // Estados de hover controlados por JS únicamente sobre enlace/toggle
  setupNavHoverStates(nav);
}

/**
 * Añade clases de hover/enfoque a los elementos interactivos del menú
 * para permitir estilos consistentes con teclado y mouse.
 * @param {HTMLElement} nav
 */
function setupNavHoverStates(nav) {
  const targets = nav.querySelectorAll('li > a, li > button.submenu-toggle');
  targets.forEach((el) => {
    const li = el.parentElement;
    if (!li) return;
    utils.on(el, 'mouseenter', () => li.classList.add('is-hover'));
    utils.on(el, 'mouseleave', () => li.classList.remove('is-hover'));
    utils.on(el, 'focus', () => li.classList.add('is-hover'));
    utils.on(el, 'blur', () => li.classList.remove('is-hover'));
  });
}

export default { initMenu };




